<template>
    <page :centered="false" delegated-loading>
        <template #title>{{$t('pages.dashboard.account.users.create-user-name.title')}}</template>

        <template #content-template>
            <m-form>
                <template #content-template>

                    <m-block-form-fields :required="false">
                        <template>
                            <e-input-user-id
                                    v-model="form.username"
                                    :organizationId="organizationIdentifierName"
                                    :loading="loadingIdentifier"
                                    @checkUserInput="checkUserId"
                                    ref="userId"
                                    :tooltip="breakpoints.isLessThanTablet ? null : userIdTooltipText"
                            />
                        </template>
                    </m-block-form-fields>
                </template>
            </m-form>
        </template>
    </page>
</template>

<script>
    import Page from "@pages/templates/page";
    import baseForm from "@mixins/components/modules/forms/base";
    import {mapActions, mapGetters} from 'vuex';

    let name = "create-user-name";
    export default {
        name: name,
        components: {
            Page
        },
        mixins: [baseForm],
        props: {
            name: {
                type: String,
                default: name
            },
        },
        data() {
            return {
                form: {
                    username: ''
                },
                loadingIdentifier: false
            }
        },
        computed: {
            ...mapGetters({
                getOrganization: 'organizations/read'
            }),
            organizationId() {
                return this.$user.relationships.organization.data.id;
            },
            organization() {
                return this.getOrganization(this.organizationId)
            },
            organizationIdentifierName() {
                return this.organization.identifierName
            },
            userIdTooltipText() {
                return this.$t('modules.forms.m-form-company-reg-step4.inputs.user-id.tooltip')
            },
            userFirstName() {
                return this.$user.attributes.firstName;
            },
            userLastName() {
                return this.$user.attributes.lastName;
            }
        },
        methods: {
            ...mapActions({
                requestOrganization: 'organizations/read',
                identify: 'users/identifier',
            }),
            async checkUserId() {
                if (!this.loadingIdentifier && this.form.username) {
                    this.loadingIdentifier = true;
                    let body = {
                        data: {
                            firstName: this.userFirstName,
                            lastName: this.userLastName,
                            userName: this.form.username,
                            organizationIdentifierName: this.organizationIdentifierName
                        }
                    }
                    try {
                        let res = await this.identify(body)
                        if (res.data.userName) this.form.username = res.data.userName
                    } catch (e) {
                        if (e.response) {
                            this.$refs.userId.invalid(e.response.data.details)
                        }
                    } finally {
                        this.loadingIdentifier = false;
                    }
                }
            },
            async setUserId() {
                if ( !this.loadingIdentifier && this.userFirstName !== '' && this.userLastName !== '') {
                    this.loadingIdentifier = true;
                    let body = {
                        data: {
                            firstName: this.userFirstName,
                            lastName: this.userLastName,
                            organizationIdentifierName: this.organizationIdentifierName
                        }
                    }
                    let res = await this.identify(body)
                    this.form.username = res.data.userName;
                    this.loadingIdentifier = false;
                }

            },
        },
        mounted() {

            // TODO: make sure organisation Identifier is set
            //this.setUserId();
        }
    }
</script>

<style scoped>

</style>